import { atom } from 'recoil';

const teamIdAtom = atom({
    key: 'teamId',
    default: null
});

export {
    teamIdAtom
};